<template>
  <div class="login-layout">
    <div class="login-layout-box">
      <div class="login-header">
        <div class="logo">
          <img
            src="//img-i.gcimg.net/2018/1219/fspfd35uex1a6k4k085832.png"
            width="40"
            height="40"
          >
        </div>
        <div class="logo-name">
          {{ title }}
        </div>
      </div>
      <slot />
    </div>
    <div class="footer">
      <p>
        <a
          href="https://help.westartrack.com/"
          target="_blank"
        >{{ helpPT.help }}</a><span>|</span><a href="/page/privacy_pact.html">  {{ helpPT.privacy }}</a> <span>|</span> <a href="/page/service_pact.html"> {{ helpPT.terms }}</a>
        <span>|</span> <a
          href="javascript:;"
          @click="changeLanguage"
        > {{ langTxt }}</a>
      </p>
      <p>Copyright © 2018  {{ $t('message["1090"]') }}</p>
    </div>
  </div>
</template>
<script>
import { getLang } from '@/lib/storage'
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    helpPT () {
      return this.$t('message["12"]')
    },
    lang () {
      return this.getLang()
    },
    langTxt () {
      const { lang } = this
      const isZh = lang === 'zh'
      return isZh ? 'English' : '简体中文'
    }
  },
  methods: {
    getLang,
    changeLanguage (type) {
      this.$getLanguage()
    }
  }
}
</script>
<style lang="scss" scoped>
  .login-layout {
    width: 400px;
    margin: 0 auto;
    padding: 50px 0;

    .login-layout-box {
      background: #fff;
      border-radius: 8px;
      width: 320px;
      padding: 40px;
      box-sizing: content-box;

      .login-header {
        padding-top: 20px;
        text-align: center;
      }

      .logo {
        width: 40px;
        height: 40px;
        display: inline-block;
        margin: 20px auto 10px;
      }

      .logo-name {
        height: 48px;
        line-height: 48px;
        font-size: 24px;
        font-weight: bold;
      }
    }

    .footer {
      text-align: center;
      padding-top: 40px;
    }

    .footer a,.footer p {
      color: #9b9b9b;
      line-height: 40px;
    }

    .footer span {
      color: #ccc;
      margin: 0 5px;
    }
  }
</style>
